import angular from 'angular';
import { MeurhContribuintesIndividuaisController } from './contribuintes-individuais.controller';

export class MeurhContribuintesIndividuaisComponent implements angular.IComponentOptions {
    static selector = 'meurhContribuintesIndividuaisComponent';
    static controller = MeurhContribuintesIndividuaisController;
    static template = require('!!html-loader!./contribuintes-individuais.html');
    static transclude = true;
    static bindings = {
        config: '=',
        busy: '=',
        onSubmit: '&',
    };
}
